export default __webpack_public_path__ + "static/media/neftify_banner.575d0801.jpeg";